// extracted by mini-css-extract-plugin
export var container = "styles-module__container___R2HpC";
export var multiline = "styles-module__multiline___WB0kc";
export var ssrContainer = "styles-module__ssrContainer___E_wLC";
export var successCheck = "styles-module__successCheck___JBztE";